import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import TeamDetail from 'components/Agile/team/teamDetail';
import TeamTable from 'components/Agile/team/teamTable';
import TeamAdd from 'components/Agile/team/teamMaintenance/teamAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchTeams,
    handleTeamRequestClose,
    showTeamLoader,
    onAddTeam,
    onToggleTeamDrawer,
} from 'actions/team';
import {
    fetchMembers,
} from 'actions/member';

const Component = () => {
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const loader = useSelector(state => state.teams.loader);
    const alertMessage = useSelector(state => state.teams.alertMessage);
    const showMessage = useSelector(state => state.teams.showMessage);
    const noContentFoundMessage = useSelector(state => state.teams.noContentFoundMessage);
    const drawerState = useSelector(state => state.teams.drawerState);
    const team = useSelector(state => state.teams.team);
    const teamList = useSelector(state => state.teams.teamList);

    useEffect(() => {
        dispatch(showTeamLoader());
        dispatch(fetchTeams());
        dispatch(fetchMembers());
    }, []);

    const teamSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.teams" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddTeam())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="team.addTeam" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    const teamRequestClose = () => {
        dispatch(handleTeamRequestClose());
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleTeamDrawer())}
                        sidebar={teamSideBar(team)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {teamSideBar(team)}
                </div>
                <div className="module-box">
                    <div className="module-box-content">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={() => dispatch(onToggleTeamDrawer())}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                teamList && teamList.length > 0 ?
                                    <Fragment>
                                        <div className="app-main-content">
                                            <TeamTable />
                                            <div style={{ marginTop: 10 }}>
                                                <TeamDetail />
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>

                    </div>
                </div>
            </div>
            <TeamAdd />

            {showMessage && NotificationManager.success(alertMessage, teamRequestClose())}
            <NotificationContainer />

        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/team/component.js